import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseEditService } from './base-edit.service';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseEditCopyService<T, TEdit> extends BaseEditService<T, TEdit> {
  protected constructor(baseRoute: string, name: string) {
    super(baseRoute, name);
  }

  copy(id: string, key?: string): Observable<string> {
    return this.httpService.get<string>(`${this.apiUrl}/Copy?id=${id}&key=${key}`);
  }
}
